/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    clearCategory: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.clearCategory',
        defaultMessage: 'Clear Category'
    },
    industryCodeSearch: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.Operation Esthetic Code Search',
        defaultMessage: 'Operation Esthetic Code Search'
    },
    Code: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.Code',
        defaultMessage: 'Code'
    },
    search: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.Search',
        defaultMessage: 'Search'
    },
    reset: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.Reset',
        defaultMessage: 'Reset'
    },
    cancel: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.Cancel',
        defaultMessage: 'Cancel'
    },
    searchResults: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.Search Results',
        defaultMessage: 'Search Results'
    },
    select: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.Select',
        defaultMessage: 'Select'
    },
    industryCode: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.Operations Code',
        defaultMessage: 'Operations Code'
    },
    descriptionOfOccupancy: {
        id: 'quoteandbind.SpaAndWellLine.templates.EstheticServicesOperations.Description Of Occupancy',
        defaultMessage: 'Description Of Occupancy'
    }
});